import React, { Component, PureComponent } from 'react'
import DataTable from '../datatable'
import { Map, List, fromJS } from 'immutable'

const columns = [
  {
    name: 'code',
    label: 'Tuotekoodi',
    width: 120,
    sortable: true,
    defaultSort: true,
    id: true,
  },
  {
    name: 'name',
    label: 'Nimi',
    sortable: true,
    id: true,
  },
  {
    name: 'data.price',
    label: 'Hinta',
    render(item, column) {
      return <div>{item.getIn(['data', 'price'], '-')} €</div>
    },
  },
  {
    name: 'data.defaultTasks',
    label: 'Oletustehtävät',
    render(item, column) {
      return <div>{item.getIn(['data', 'defaultTasks'], List()).size}</div>
    },
  },
  {
    name: 'created_at',
    label: 'Luotu',
    date: 'DD.MM.YYYY - HH:mm',
    width: 200,
    sortable: true,
  },
]

export default function ProductRoot() {
  return (
    <DataTable
      id="products"
      entity="product"
      columns={columns}
      dataId="code"
      crud
      title="Tuotteet"
      texts={{
        createButton: 'Lisää tuote',
      }}
    />
  )
}
